import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-bulk-sms',
    templateUrl: './bulk-sms.component.html',
    styleUrls: ['./bulk-sms.component.css'],
    standalone: false
})
export class BulkSmsComponent implements OnInit {

  constructor( private title : Title ) { }

  ngOnInit(): void {
    this.title.setTitle('Bulk SMS | Resiliencesoft')
  }

}
